import {DataSource} from '@angular/cdk/collections';
import {Input} from '@angular/core';

export enum TdoTableActionsEnum {
  NONE = 'none',
  EDIT = 'edit',
  DELETE = 'delete',
}

export class TdoTableModel {
  displayedColumns: Array<string>;
  editableColumns: string[];
  displayedColumnsLabels: Array<string>;
  dataSource: DataSource<any>;
  sortActive: string = null;
  sortDirection: string = null;
  searchPredicate: (data: any, filter: string) => boolean;

  private displayedColumnsLabelsMap: Map<string, string>;

  /**
   * TdoTableModel helps facilitate required data to hook everything up.
   * @param displayedColumns A list of keys to use from each object for column values.
   * @param displayedColumnsLabels A list of labels for each column
   * @param dataSource MatTableDataSource
   * @param sortActive (Optional) The active column being sorted
   * @param sortDirection (Optional) The sort direction of the active column
   */
  constructor(displayedColumns: Array<string>, displayedColumnsLabels: Array<string>, dataSource: DataSource<any>,
              sortActive: string = null, sortDirection: string = null) {
    this.displayedColumns = displayedColumns;
    this.displayedColumnsLabels = displayedColumnsLabels;
    this.dataSource = dataSource;
    this.sortActive = sortActive;
    this.sortDirection = sortDirection;

    this.displayedColumnsLabelsMap = new Map<string, string>();
    for (let i = 0; i < this.displayedColumns.length; i++) {
      const key = this.displayedColumns[i];
      this.displayedColumnsLabelsMap.set(key, displayedColumnsLabels[i]);
    }
  }

  /**
   * getLabelByKey is used internally in the template
   * @param key The key the system wants the value of as it iterates the object
   */
  getLabelByKey(key: string): string {
    return this.displayedColumnsLabelsMap.get(key);
  }
}
